
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2318","transform":"translate(-18076 -270)","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Polygon 163","d":"M18081.241 270.886a1 1 0 011.519 0l3.826 4.463a1 1 0 01-.76 1.651h-7.652a1 1 0 01-.759-1.651z"}}),_c('path',{attrs:{"data-name":"Polygon 164","d":"M18092.759 286.114a1 1 0 01-1.519 0l-3.826-4.463a1 1 0 01.76-1.651h7.652a1 1 0 01.759 1.651z"}}),_c('rect',{attrs:{"data-name":"Rectangle 4011","width":"2","height":"10","rx":"1","transform":"translate(18081 276)"}}),_c('rect',{attrs:{"data-name":"Rectangle 4012","width":"2","height":"10","rx":"1","transform":"rotate(180 9046.5 140.5)"}})])])
          )
        }
      }
    